import React from 'react';
import Slideshow from './Slideshow';
import { XMarkIcon } from '@heroicons/react/24/outline';

export interface ModalContent {
  title: string;
  main: string | React.ReactNode;
  details: React.ReactNode;
  media: (string | { type: 'image' | 'youtube' | 'mp4'; src: string })[];
  footerContent?: React.ReactNode;
}

interface SectionModalProps {
  content: ModalContent | null;
  onClose: () => void;
}

const SectionModal: React.FC<SectionModalProps> = ({ content, onClose }) => {
  if (!content) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 flex items-start justify-center z-50 p-4 animate-fade-in pt-16"
      onClick={onClose}
    >
      <div 
        className="bg-gray-800 text-white rounded-lg shadow-xl w-full max-w-4xl max-h-[85vh] overflow-y-auto mt-8"
        onClick={e => e.stopPropagation()}
      >
        <div className="p-8 relative">
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-gray-400 hover:text-white z-10"
          >
            <XMarkIcon className="h-8 w-8" />
          </button>
          <div className="pr-10">
            <h2 className="text-4xl font-bold mb-4 text-blue-300 mt-4">{content.title}</h2>
            {content.main && (
              <p className="mb-6 text-gray-400 leading-relaxed">{content.main}</p>
            )}
            <div className="space-y-6 mb-8 text-gray-400 leading-relaxed">{content.details}</div>
          </div>
          <Slideshow media={content.media} />
          {content.footerContent && (
            <div className="pt-6 mt-6 border-t border-gray-700">
              {content.footerContent}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionModal; 